import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { subscriptionActions } from '../../actions';
import { BraintreeSubscribeActionPayload } from '../../typedefs';

export function* braintreeSubscribe({
  payload,
}: PayloadAction<BraintreeSubscribeActionPayload>) {
  try {
    yield effects.put(subscriptionActions.setSubscribing(true));
    const body: string = yield effects.call(JSON.stringify, payload);
    const response: Response = yield effects.apply(api, api.post, [
      { endpoint: 'payments/brain_tree/subscription/', body },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(subscriptionActions.setSubscribing(false));
  }
}
